<template>
  <div class="actuals-filter-chips driver-actuals-filter-chips">
    <span
      class="actuals-chip actuals-chip-clickable actuals-chip-total"
      :class="{ 'actuals-chip-selected': selectedStatus == null }"
      @click="toggle(null)"
    >{{ itemsCount }}/{{ itemsFullCount }}</span>
    <span class="actuals-filter-sep">|</span>
    <span class="actuals-filter-label">Status</span>
    <span
      class="actuals-chip actuals-chip-clickable success"
      :class="{ 'actuals-chip-selected': selectedStatus === 'success' }"
      @click="toggle('success')"
    >Success {{ successCount }}</span>
    <span
      class="actuals-chip actuals-chip-clickable error"
      :class="{ 'actuals-chip-selected': selectedStatus === 'error' }"
      @click="toggle('error')"
    >Errors {{ errorCount }}</span>
    <span
      class="actuals-chip actuals-chip-clickable cancelled"
      :class="{ 'actuals-chip-selected': selectedStatus === 'cancelled' }"
      @click="toggle('cancelled')"
    >Cancelled {{ cancelledCount }}</span>
    <span
      class="actuals-chip actuals-chip-clickable unprocessed"
      :class="{ 'actuals-chip-selected': selectedStatus === 'unprocessed' }"
      @click="toggle('unprocessed')"
    >Unprocessed {{ unprocessedCount }}</span>
    <span
      v-if="showSkipped"
      class="actuals-chip actuals-chip-clickable skipped"
      :class="{ 'actuals-chip-selected': selectedStatus === 'skipped' }"
      @click="toggle('skipped')"
    >Skipped {{ skippedCount }}</span>
    <span class="actuals-filter-sep">|</span>
    <span
      class="actuals-chip actuals-chip-clickable"
      :class="[overlapChipClass, { 'actuals-chip-selected': selectedStatus === overlapFilterKey }]"
      :title="overlapTitle"
      @click="toggle(overlapFilterKey)"
    >Overlap {{ overlapCount }}</span>
  </div>
</template>

<script>
export default {
  name: 'driver_actuals_filter_chips',

  props: {
    itemsFull: { type: Array, default: () => [] },
    itemsCount: { type: Number, default: 0 },
    selectedStatus: { default: null },
    showSkipped: { type: Boolean, default: false },
    overlapFilterKey: { type: String, default: 'driver_overlap' },
    overlapTitle: { type: String, default: 'Duty times overlap another booking' },
    overlapChipClass: { type: String, default: 'overlap-driver' },
  },

  computed: {
    itemsFullCount() {
      return (this.itemsFull || []).length
    },
    statusCounts() {
      const counts = {
        success: 0,
        error: 0,
        cancelled: 0,
        unprocessed: 0,
        skipped: 0,
        overlap: 0,
      }
      const overlapKey = this.overlapFilterKey
      for (const item of this.itemsFull || []) {
        if (item[overlapKey])
          counts.overlap++
        if (counts[item.status] !== undefined)
          counts[item.status]++
      }
      return counts
    },
    successCount() {
      return this.statusCounts.success
    },
    errorCount() {
      return this.statusCounts.error
    },
    cancelledCount() {
      return this.statusCounts.cancelled
    },
    unprocessedCount() {
      return this.statusCounts.unprocessed
    },
    skippedCount() {
      return this.statusCounts.skipped
    },
    overlapCount() {
      return this.statusCounts.overlap
    },
  },

  methods: {
    toggle(status) {
      const next = (status == null || this.selectedStatus === status) ? null : status
      this.$emit('filter', next)
    },
  },
}
</script>

<style>
.driver-actuals-filter-chips {
  margin: 12px 8px;
}
.driver-actuals-filter-chips .actuals-filter-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
}
.actuals-filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
}
.actuals-filter-sep {
  color: #adb5bd;
  margin: 0 2px;
}
.actuals-chip {
  display: inline-block;
  padding: 4px 10px;
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  background-color: #f8f9fa;
  white-space: nowrap;
}
.actuals-chip-clickable {
  cursor: pointer;
}
.actuals-chip-clickable:hover {
  opacity: 0.88;
}
.actuals-chip-selected:not(.actuals-chip-total) {
  outline: 2px solid #495057;
  outline-offset: 1px;
}
.actuals-chip-total.actuals-chip-selected {
  border: 1px solid #ccc !important;
  box-shadow: none !important;
  outline: none;
}
.actuals-chip.success { background-color: hsla(120, 100%, 75%, 0.55); border-color: #7dcc7d; }
.actuals-chip.error { background-color: rgba(255, 0, 0, 0.2); border-color: #e88; }
.actuals-chip.unprocessed { background-color: hsla(200, 40%, 55%, 0.55); border-color: #5f7d8f; }
.actuals-chip.skipped { background-color: hsla(190, 90%, 80%, 0.55); border-color: #8cc; }
.actuals-chip.cancelled { background-color: hsla(290, 60%, 70%, 0.45); border-color: #b9b; }
.actuals-chip.overlap-driver { background-color: hsla(35, 100%, 70%, 0.65); border-color: #e6a23c; color: #7c4a03; }
.actuals-chip.overlap-vehicle { background-color: hsla(35, 100%, 70%, 0.65); border-color: #e6a23c; color: #7c4a03; }
</style>
